import { SeoRenderer } from "../../../common/helpers/seo";

import loadable from "./loadable";

export default {
    component: loadable,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["article.filters.title"],
            description: allMessage["article.filters.description"],
            allMessage,
            lang,
        });
    },
};
